import { createFileRoute } from '@tanstack/react-router';

import { RewriteListEditorPage } from '../features/supply/lists/components/RewriteListEditorPage/RewriteListEditorPage';

export const Route = createFileRoute('/supply/lists_/rewrite_/create')({
  component: RewriteListEditorPage,
});
